const backendUrl = process.env.REACT_APP_BACKEND_URL; 




export async function fetchCustomerTypes() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/customer_type`);
        if (!response.ok) throw new Error("Failed to fetch customer types");
        return await response.json();
    } catch (error) {
        console.error("Error fetching customer types:", error);
        return [];
    }
}

export async function fetchIDTypes() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/id_type`);
        if (!response.ok) throw new Error("Failed to fetch ID types");
        return await response.json();
    } catch (error) {
        console.error("Error fetching ID types:", error);
        return [];
    }
}

export async function fetchTermOfPayment() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/term_of_payment`);
        if (!response.ok) throw new Error("Failed to fetch ID types");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Term Of Payments:", error);
        return [];
    }
}

export async function fetchTIP() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/tax_invoice_type`);
        if (!response.ok) throw new Error("Failed to fetch Tax Invoice Type");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Tax Invoice Type:", error);
        return [];
    }
}

export async function fetchBehaviour() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/Behaviour`);
        if (!response.ok) throw new Error("Failed to fetch Behaviour");
        return await response.json();
    } catch (error) {
        console.error("Error fetching Behaviour:", error);
        return [];
    }
}

export async function fetchjobtitle() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/jobtitle`);
        if (!response.ok) throw new Error("Failed to fetch jobtitle");
        return await response.json();
    } catch (error) {
        console.error("Error fetching jobtitle:", error);
        return [];
    }
}

export async function fetchprovinsi() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/provinsi`);
        if (!response.ok) throw new Error("Failed to fetch provinsi");
        return await response.json();
    } catch (error) {
        console.error("Error fetching provinsi:", error);
        return [];
    }
}



export async function saveCustomerData(customerData) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(customerData),
        });

        if (!response.ok) {
            throw new Error('Failed to save customer data');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error saving customer data:', error);
        throw error;
    }
}


export async function saveBankData(data) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/save-bank`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data), 
        });

        if (!response.ok) {
            throw new Error('Failed to save bank data');
        }

        return await response.json();
    } catch (error) {
        console.error('Error saving bank data:', error);
        throw error;
    }
}


export async function saveCopData(data) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/save-cop`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error('Failed to save COP data');
        }

        return await response.json();
    } catch (error) {
        console.error('Error saving COP data:', error);
        throw error;
    }
}



export async function saveCstaData(data) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/save-csta`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error('Failed to save CSTA data');
        }

        return await response.json();
    } catch (error) {
        console.error('Error saving CSTA data:', error);
        throw error;
    }
}



export async function fetchCustomerList() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/list-data`);
        if (!response.ok) throw new Error("Failed to fetch customer list");
        return await response.json();
    } catch (error) {
        console.error("Error fetching customer list:", error);
        return [];
    }
}

export async function generateCustomerCode() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/last_customer_code`);
        if (!response.ok) throw new Error("Gagal mengambil kode pelanggan terakhir");

        const data = await response.json();
        const lastCode = data.lastCode;  

        const lastNumber = parseInt(lastCode.substring(3));  
        const newNumber = lastNumber + 1;  
        const newCode = "101" + newNumber.toString().padStart(7, '0');  

        return newCode;
    } catch (error) {
        console.error("Error generating customer code:", error);
        return "1010000000";  
    }
}

export async function fetchKabupatenByProvinsi(kodeProvinsi) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/kabupaten?kode_provinsi=${kodeProvinsi}`);
        if (!response.ok) throw new Error("Failed to fetch kabupaten");
        return await response.json();
    } catch (error) {
        console.error("Error fetching kabupaten:", error);
        return [];
    }
}

export async function fetchKecamatanByKabupaten(kodeDati) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/kecamatan?kode_dati=${kodeDati}`);
        if (!response.ok) throw new Error("Failed to fetch kecamatan");
        return await response.json();
    } catch (error) {
        console.error("Error fetching kecamatan:", error);
        return [];
    }
}

export async function fetchKelurahanByKecamatan(kodeKecamatan) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/kelurahan?kode_kecamatan=${kodeKecamatan}`);
        if (!response.ok) throw new Error("Failed to fetch kelurahan");
        return await response.json();
    } catch (error) {
        console.error("Error fetching kelurahan:", error);
        return [];
    }
}

export async function fetchvattrans() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/vat_trans`);
        if (!response.ok) throw new Error("Failed to fetch vattrans");
        return await response.json();
    } catch (error) {
        console.error("Error fetching vattrans:", error);
        return [];
    }
}
export async function fetchbusinesstype() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/business_type`);
        if (!response.ok) throw new Error("Failed to fetch businesstype");
        return await response.json();
    } catch (error) {
        console.error("Error fetching businesstype:", error);
        return [];
    }
}
export async function fetchcompanygroup() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/company_group`);
        if (!response.ok) throw new Error("Failed to fetch companygroup");
        return await response.json();
    } catch (error) {
        console.error("Error fetching companygroup:", error);
        return [];
    }
}
export async function fetchcssbank() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/css_daftar_bank`);
        if (!response.ok) throw new Error("Failed to fetch cssbank");
        return await response.json();
    } catch (error) {
        console.error("Error fetching cssbank:", error);
        return [];
    }
}
export async function fetchcurrency() {
    try {
        const response = await fetch(`${backendUrl}/api/customers/css_currency`);
        if (!response.ok) throw new Error("Failed to fetch currency");
        return await response.json();
    } catch (error) {
        console.error("Error fetching currency:", error);
        return [];
    }
}

export async function updateCustomerData(data) {
    try {
      const response = await fetch(`${backendUrl}/api/customers/update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      
      if (!response.ok) {
        throw new Error('Failed to update customer data');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error updating customer data:', error);
      throw error;
    }
  }

  export async function fetchBankData(cs_code) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/bank/${cs_code}`);
        if (!response.ok) throw new Error("Failed to fetch bank data");
        return await response.json();
    } catch (error) {
        console.error("Error fetching bank data:", error);
        return [];
    }
}

export async function fetchCopData(cs_code) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/cop/${cs_code}`);
        if (!response.ok) throw new Error("Failed to fetch cop data");
        return await response.json();
    } catch (error) {
        console.error("Error fetching cop data:", error);
        return [];
    }
}

export async function fetchCstaData(cs_code) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/csta/${cs_code}`);
        if (!response.ok) throw new Error("Failed to fetch csta data");
        return await response.json();
    } catch (error) {
        console.error("Error fetching csta data:", error);
        return [];
    }
}

export async function updateBankData(data) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/update-bank`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        
        if (!response.ok) {
            throw new Error('Failed to update bank data');
        }
        
        return await response.json();
    } catch (error) {
        console.error('Error updating bank data:', error);
        throw error;
    }
}

export async function updateCopData(data) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/update-cop`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        
        if (!response.ok) {
            throw new Error('Failed to update cop data');
        }
        
        return await response.json();
    } catch (error) {
        console.error('Error updating cop data:', error);
        throw error;
    }
}

export async function updateCstaData(data) {
    try {
        const response = await fetch(`${backendUrl}/api/customers/update-csta`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        
        if (!response.ok) {
            throw new Error('Failed to update csta data');
        }
        
        return await response.json();
    } catch (error) {
        console.error('Error updating csta data:', error);
        throw error;
    }
}